import React, { useState, useEffect, useCallback } from "react";
import { Typography, Table, Tag, Button, Modal, Tooltip, Space } from "antd";
import {CheckCircleOutlined, InfoCircleOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
import IssueFilters from "../filter/index";
import Pageloader from "../../../components/loader/index";
import { dataKey, DevDummyPermissionHelper, typeOption, userhasPermissionHelper } from "../../../utils/Helpers";
import moment from 'moment';
import * as issuesActions from "../../../redux/actions/issues.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../../utils/constants/app";
const { Title, Text } = Typography;

const pageName = "Open Issues";

const OpenIssue = (props) => {
  const [postData, setPostData] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState({});
  const [formModalOpenComplete, setFormModalOpenComplete] = useState({});
  const [paginationSave, setPaginationSave] = useState({});
  const [dataFilters, setDataFilters] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    if (props.pageFilter) {dataRun({...props.pageFilter, page: 1, limit: 10})}
  }, [props.pageFilter]);

  const dataRun = useCallback((value)=>{
    const param = `open`
    const [start, end] = (value?.date === null || value?.date === undefined) ? "" : value?.date;
    const pageFilterData = {
      ...value,
      startDate: start === undefined ? moment().toISOString() : start.toISOString(),
      endDate: end === undefined ? moment().toISOString() : end.toISOString(),
    };
    delete pageFilterData["date"];
    props.issuesActions.listAction(param, pageFilterData);
  },[])

  useEffect(() => {
    if (props?.pageData){setPostData(dataKey(props?.pageData))}
  }, [props?.pageData]);

  const paginationChange = useCallback((currentPage, limit) => {
    const pageData = {
      ...props.pageFilter,
      page: currentPage,
      limit: limit,
    };
    setPaginationSave({page: currentPage, limit: limit});
    dataRun(pageData);
    // props.issuesActions.filterAction(pageData);
  },[props.pageFilter]);

  const columns = [
    {
      title: 'Issue id',
      dataIndex: 'display_id',
      render: (value) => ( value || "-" )
    },
    // {
    //   title: 'Task Type',
    //   dataIndex: 'task_type',
    //   render: (value) => ( value || "-" )
    // },
    {
      title: 'Issue Created At',
      dataIndex: 'createdAt',
      render: (value) => {
        return value ?
        <><span>{moment(value).format("DD MMMM, yyyy")}</span>
        <p>{moment(value).format("h:mm A")}</p></>:"-"
      }
    },
    {
      title: 'Issue',
      render: (value) => (
      <>
        {value?.issues_type_category && <p>{value.issues_type_category}</p>}
        <Text style={{textTransform: 'capitalize', marginRight: "5px"}}>{value.type.replace(/_/g, ' ')}</Text>
        {value.type === typeOption[0]?.value && <Tooltip title={<>
          Order not Packed<br/>
          No packtime<br/>
          (Now - Order creation time) <RightOutlined /> 5 mins<br/>
          Success: when order is Packed<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value.type === typeOption[1]?.value && <Tooltip title={<>
          Order not accepted<br/>
          Has packtime<br/>
          Free rider is <RightOutlined /> 0<br/>
          not accepted by any rider<br/>
          pending (now - order packed time)  since 5 mins (customizable)<br/>
          Success: when order is accepted<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value.type === typeOption[2]?.value && <Tooltip title={<>
          Order not Picked up<br/>
          Has picture packed time<br/>
          Accepted by rider = true<br/>
          rider reach mart = true<br/>
          Pick successful up by rider = false<br/>
          Pending (Now - Rider reach at mart time) <RightOutlined /> 5 mins<br/>
          Success: when order is picked up<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value.type === typeOption[3]?.value && <Tooltip title={<>
          Order has PACKED TIME<br/>
          Shipped quantity <LeftOutlined /> total ordered quantity<br/>
          Success:<br/>
          when dispatch note contains<br/>
          Partial - Customer NR Order Cancelled Auto Partial<br/>
          Partial - Customer Not Agree for Partial Delivery<br/>
          Partial - Customer Agree for Partial Delivery<br/>
          Partial - Customer NR Proceed with Partial Invoice<br/>
          Or order status is cancelled or delivered<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value.type === typeOption[4]?.value && <Tooltip title={<>
          Order is created by new customer (has N icon in Overview page)<br/>
          Order creation time - now (time) > 45 mints<br/>
          Order status is NOT Dropoff Successful/Canceled<br/>
          Success:<br/>
          When order status is Delivered/Canceled<br/>
        </>}><InfoCircleOutlined /></Tooltip>}
        {value.type === typeOption[5]?.value && <Tooltip title={<>
          Criteria:<br/>
          New customer order: YES<br/>
          Order status = Canceled<br/>
          Success:<br/>
          When 72 hours passed OR<br/>
          Marked complete by Growth team
        </>}><InfoCircleOutlined /></Tooltip>}
      </> 
        || 
      "-" )
    },
    {
      title: 'Courier',
      dataIndex: 'rider',
      render: (value) => {
        return <>
          <div className="table-inner">
            {value ? <a onClick={()=>window.open(`rider/${value?._id}`)} >{`${value.display_id} - ${value.fullName}`}</a>:"-"}
            <span>{value?.phoneNumber || "-"}</span>
          </div>
        </>;
      },
    },
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      render: (value) => (<a onClick={()=>window.open(`overview/${value}`)}>{`${value}`}</a>|| "-" )
    },
    {
      title: 'Zone',
      dataIndex: 'zone',
      render: (value) => ( value?.zoneName || "-" )
    },
    // {
    //   title: 'Deadline',
    //   dataIndex: 'order_id',
    //   render: (value) => ( "--" || "-" )
    // },
    
    // {
    //   title: 'Deadline',
    //   dataIndex: 'deadline',
    //   render: (value) => {
    //     return value ?
    //     <><span>{moment(value).format("DD MMMM, yyyy")}</span>
    //     <p>{moment(value).format("h:mm A")}</p></>:"-"
    //   }
    // },
    {
      title: 'Issue Closed Time',
      dataIndex: 'completeAt',
      render: (value) => {
        return value ?
        <><span>{moment(value).format("DD MMMM, yyyy")}</span>
        <p>{moment(value).format("h:mm A")}</p></>:"-"
      }
    },
    {
      title: 'Open for',
      render: (value) => {
        var ms = moment(moment().format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss").diff(moment(moment(value?.createdAt).format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss"));
        var d = moment.duration(ms);
        return d && value?.status !== 'complete' ?
          // <Text type={ms/60000 < 15? "success":"danger"}>
          <Text>
            <span>{d._data.days === 0?"":d._data.days+"Day"}</span>
            <p>{d._data.hours === 0 ? "" : `${('0'+d._data.hours).slice(-2)}hr`} {`${('0'+d._data.minutes).slice(-2)}mints`}</p>
          </Text>
        : <Tag icon={<CheckCircleOutlined />} color="success">Completed</Tag>
      },
    },
    // {
    //   title: 'Statu',
    //   dataIndex: 'status',
    //   render: (value) => ( value || "-" )
    // },
    {
      title: 'Order Delay',
      render: (value) => {
        let time = null;
        if(value?.order?.createdAt) { 
          let now = moment();
          let end = moment(value?.order?.createdAt);
          time = moment.duration(now.diff(end)).asMinutes();
        } 
        return time ? <Text>
          <span>{Math.floor(time/24/60) === 0?"":Math.floor(time/24/60)+"Day"}</span>
          <p>{('0'+Math.floor(time/60%24)).slice(-2) + ':' + ('0'+Math.floor(time%60)).slice(-2)}</p>
        </Text>: "-"
      },
    },
    {
      title: 'Action',
      render: (value) => {
        const hasPickPermission = userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICK_ISSUE);
        const hasMarkPermission = userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_MARK_COMPLETE);
        const isPicked = !!value?.rs_user?.id;
        const isComplete = value?.status === 'complete';

        return (
          <>
            {isPicked ? (
              <Text>
                <p>{value?.rs_user?.name || "--"}</p>
              </Text>
            ) : (
              hasPickPermission && (
                <Button
                  onClick={() => onCreateAction({ modal: true, value: { issue_id: value?._id }, type: 'pick' })}
                >
                  Pick Issue
                </Button>
              )
            )}

            {hasMarkPermission && (
              <Button
                style={{ marginLeft: 5 }}
                disabled={isComplete}
                onClick={() => onAction(value?._id, 'Process')}
              >
                Mark Complete
              </Button>
            )}
          </>
        );
      }
    },
  ]


 // Modal Start **********************
 const handleFormCancel = useCallback(()=> {
  setFormModalOpen({})
}, [])

const onAction = useCallback((value, type=null) => {
  if (type === 'pick') {
    setFormModalOpen(()=>({
      modal: true,
      value: {
        "issue_id": value
      },
      type: type,
    }))
  } else if (type === 'Process') {
    setFormModalOpen(()=>({
      modal: true,
      value: {
        "issue_id": value
      },
      type: type,
    }))
  }
}, [setFormModalOpen]);

const onCreateAction = async (data) => {
  try {
    if (data?.type === 'pick') {
      const addData = {
        ...data?.value,
      }
      await props.issuesActions.pickAction(addData);
      dataRun({...props.pageFilter, ...paginationSave});
      handleFormCancel();
    } else if (data?.type === 'Bulk Pick') {
      const selectedIds = data?.value;
      await props.issuesActions.pickBulkAction(selectedIds);
      dataRun({...props.pageFilter, ...paginationSave});
      handleFormCancel();
      setSelectedRowKeys([]);
      setSelectedRows([]);
    } else if (data?.type === 'Process') {
      const addData = {
        ...data?.value,
      }
      await props.issuesActions.inProcessAction(addData);
      dataRun({...props.pageFilter, ...paginationSave});
      handleFormCancel();
    }
  } catch (e) {}
}

// const onCreateActionComplete = async (data) => {
//   try {
//     if (data?.type === 'pick') {
//       const addData = {
//         ...data?.value,
//       }
//       await props.issuesActions.pickAction(addData);
//       dataRun();
//       handleFormCancel();
//     }
//   } catch (e) {}
// }
// Modal End **********************

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(newSelectedRows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handlePickBulkSubmit = async () => {
    const selectedIds = selectedRows.map((row) => row._id);
    try {
      setFormModalOpen(()=>({modal: true, value: selectedIds, type: "Bulk Pick",}));
    } catch (err) {
      console.error(err);
    }
  };

  const clearPickBulkSelection = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  return (<>
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{pageName}</Title>
        <div></div>
      </div>
      <IssueFilters dataFilters={dataFilters} setDataFilters={setDataFilters} />
      {selectedRowKeys.length > 0 && (
        <Space style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={handlePickBulkSubmit}>
            Bulk Pick Issue
          </Button>
          <Button onClick={clearPickBulkSelection}>Clear Selection</Button>
        </Space>
      )}
      <div className="p-content">
        {props?.pageLoader ? <Pageloader /> :
          <Table
            dataSource={postData}
            rowSelection={rowSelection}
            columns={columns}
            pagination={props?.pagePagination?.length !== 0 ?{
              total: props?.pagePagination?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: props?.pagePagination?.limit,
              defaultCurrent: props?.pagePagination?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (currentPage, pageSize) => {paginationChange(currentPage, pageSize)},
            } : ""}
          />
        }
      </div>
    </div>
    <Modal
      title={`${pageName} ${formModalOpen['type']}`}
      visible={formModalOpen['modal']}
      okText={`Confirm ${formModalOpen['type']}`}
      cancelText="Cancel"
      onCancel={()=>handleFormCancel()}
      onOk={()=>onCreateAction(formModalOpen)}
    >
      Are you sure to perform this action ?
    </Modal>

    {/* <Modal
      title={`${pageName} ${formModalOpenComplete['type']}`}
      visible={formModalOpenComplete['modal']}
      okText={`Confirm ${formModalOpenComplete['type']}`}
      cancelText="Cancel"
      onCancel={()=>handleFormCancel()}
      onOk={()=>onCreateActionComplete(formModalOpenComplete)}
    >
      Are you sure to perform this action ?
    </Modal> */}
    
  </>);
};

const mapStateToProps = (state) => {
  return {
    pageData: state.IssuesReducer.initialData,
    pageLoader: state.IssuesReducer.initialLoading,
    pagePagination: state.IssuesReducer.initialPagination,
    pageFilter: state.IssuesReducer.initialFilter,
    user: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    issuesActions: bindActionCreators(issuesActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenIssue);